import { render } from "./CustomerStatsExpanded.vue?vue&type=template&id=bd4586fc"
import script from "./CustomerStatsExpanded.vue?vue&type=script&lang=js"
export * from "./CustomerStatsExpanded.vue?vue&type=script&lang=js"

import "./CustomerStatsExpanded.vue?vue&type=style&index=0&id=bd4586fc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__